import React from 'react';
import clsx from 'clsx';
import styles from './PillCellRenderer.module.scss';

/**
 * @param inactiveTone - how the NOT-active pill reads. 'neutral' (default) is the grey used for
 * plain Yes/No columns; 'risk' is the red Figma specifies where inactive means "Former" — a fact
 * about the person, not just a boolean. Opt-in because this renderer is shared with Manage Users
 * and the Mandate Sharing drawer, where red would wrongly imply risk.
 */
export const PillCellRenderer = ({
    label,
    isActive,
    inactiveTone = 'neutral',
}: {
    label: React.ReactNode;
    isActive: boolean;
    inactiveTone?: 'neutral' | 'risk';
}) => {
    if (isActive) return <span className={styles.PillActive}>{label}</span>;
    return <span className={clsx(styles.PillInactive, { [styles.PillRisk]: inactiveTone === 'risk' })}>{label}</span>;
};
